export default __webpack_public_path__ + "static/media/luxelectrical.7c23fbc0.png";